//@flow
import React from 'react';
//Components
import { Link } from 'react-router-dom';
//Styles
import './DepartmentCards.css';
//Types
import type { Department } from '../../departments/types';

type Props = {
  departmentsData: Array<Department>,
  isLoading?: boolean,
};

const DepartmentCards = ({ departmentsData = [], isLoading }: Props) => {
  const departments = departmentsData.slice(0, 5).sort(d => d.position);

  if (isLoading) {
    return (
      <div className="department-cards-container">
        <div className="department-cards-wrapper">
          {[0, 1, 2, 3, 4].map(i => (
            <div key={i} className="department-cards-item">
              <div className="department-cards-skeleton-img skeleton-block" />
              <div className="department-cards-skeleton-text skeleton-block" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="department-cards-container">
      {departments.length > 0 && (
        <div className="department-cards-wrapper">
          {departments.map((d, i) => (
            <Link
              to={`/departamentos/${d.id}/`}
              key={i}
              className="department-cards-item"
            >
              <img
                className="department-cards-item-img"
                src={d.imageUrl}
                alt={d.name}
                draggable={false}
              />
              <p className="department-cards-item-description">
                {d.name.toLowerCase()}
              </p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default DepartmentCards;
